import $ from 'jquery';

$(() => {
  $(document).on('click', '.more-faq', (e: JQuery.ClickEvent) => {
    e.preventDefault();
    $('.more-faq').addClass('d-none');
    $('.faq-item-more').addClass('show');
  });
});
